import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e3f685"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "order-list" }
const _hoisted_4 = {
  key: 0,
  class: "g-card order-item-content"
}
const _hoisted_5 = { class: "package-info" }
const _hoisted_6 = { class: "item-header" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "item-row" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单保价", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "保费", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "item-row" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "包裹数量", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "税费", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "item-row" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "item-row" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "package-attr-info" }
const _hoisted_30 = ["data-info"]
const _hoisted_31 = { class: "item-header" }
const _hoisted_32 = { class: "price" }
const _hoisted_33 = { class: "item-footer" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "icon" }
const _hoisted_37 = { class: "footer-ctrl" }
const _hoisted_38 = { class: "left-menu" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coupon-title" }, "优惠券", -1))
const _hoisted_40 = { class: "right-menu" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "use-coupon"
}
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { class: "footer-bar" }
const _hoisted_45 = { class: "bar-price" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合计", -1))
const _hoisted_48 = { class: "price" }
const _hoisted_49 = {
  key: 0,
  class: "row discount"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "已优惠", -1))
const _hoisted_51 = { class: "price" }
const _hoisted_52 = { class: "coupon-dialog" }
const _hoisted_53 = {
  key: 1,
  class: "picker-dialog"
}
const _hoisted_54 = { class: "header" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "优惠券", -1))
const _hoisted_56 = { class: "coupon-content" }
const _hoisted_57 = { class: "coupon-icon" }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "coupon-info" }
const _hoisted_60 = { class: "coupon-title" }
const _hoisted_61 = { class: "coupon-condition" }
const _hoisted_62 = { class: "limit" }
const _hoisted_63 = { class: "express-tag" }
const _hoisted_64 = { class: "coupon-footer" }
const _hoisted_65 = { class: "date" }
const _hoisted_66 = {
  key: 0,
  class: "message"
}
const _hoisted_67 = { class: "message-label" }
const _hoisted_68 = { class: "message-content" }
const _hoisted_69 = ["value", "checked"]
const _hoisted_70 = {
  key: 1,
  class: "empty-coupon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "order-item",
            key: item.id
          }, [
            (item['id'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(item.package_num), 1),
                      _createElementVNode("span", _hoisted_7, "￥" + _toDisplayString(item.price), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Icon, {
                          class: "icon",
                          icon: "icon_baozhi"
                        }),
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, "￥" + _toDisplayString(item.declare_amount), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Icon, {
                          class: "icon",
                          icon: "icon_baojia"
                        }),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.declare_price ? '￥' + item.declare_price : '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_Icon, {
                          class: "icon",
                          icon: "icon_box"
                        }),
                        _hoisted_17,
                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.package_attr.length) + "个", 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Icon, {
                          class: "icon",
                          icon: "icon_shuifei"
                        }),
                        _hoisted_20,
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.clearance_declare_price
                      ? item.clearance_declare_price
                      : '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Icon, {
                          class: "address-icon",
                          icon: "icon_user"
                        }),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(item.firstname) + " " + _toDisplayString(item.last_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Icon, {
                          class: "address-icon",
                          icon: "icon_phone"
                        }),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(item.mobile || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Icon, {
                        class: "address-icon",
                        icon: "icon_address"
                      }),
                      _createElementVNode("span", null, _toDisplayString(item.address1) + " " + _toDisplayString(item.address2 || '') + ", " + _toDisplayString(item.city) + ", " + _toDisplayString(item.state) + " " + _toDisplayString(item.zipcode) + " , " + _toDisplayString(item.country), 1),
                      _createElementVNode("img", {
                        class: "country-icon",
                        src: item.country_icon
                      }, null, 8, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.package_attr, (packageAttr) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "package-attr-item",
                        "data-info": packageAttr,
                        key: packageAttr.id
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", null, _toDisplayString(packageAttr.package_attr_num), 1),
                          _createElementVNode("div", null, [
                            _createTextVNode(" 运费"),
                            _createElementVNode("span", _hoisted_32, "￥" + _toDisplayString(packageAttr.price), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(packageAttr.express_title), 1),
                          _createElementVNode("div", {
                            class: "more",
                            onClick: _withModifiers(($event: any) => (_ctx.toDetail(packageAttr.id)), ["stop"])
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createTextVNode(" 查看详情 "),
                              _createVNode(_component_Icon, { icon: "btn_arrow_right" })
                            ])
                          ], 8, _hoisted_35)
                        ])
                      ], 8, _hoisted_30))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", {
        class: "coupon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCoupon && _ctx.openCoupon(...args)))
      }, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_Icon, {
            class: "coupon-icon",
            icon: "quan"
          }),
          _hoisted_39
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_ctx.hasCoupon && !_ctx.selectdCoupon.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, "您有优惠券可使用"))
            : (_ctx.selectdCoupon.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.selectdCoupon.coupon_type == 'Free'
                ? '抵扣券'
                : '减' + _ctx.selectdCoupon.coupon_amount + '元'), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, "暂无可用券")),
          _createVNode(_component_Icon, {
            class: "arrow-right",
            icon: "btn_arrow_right"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, "¥" + _toDisplayString(_ctx.paymentInfo.pay_order_amount), 1)
          ]),
          (_ctx.paymentInfo.coupon_amount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, "¥" + _toDisplayString(_ctx.paymentInfo.coupon_amount), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "g-button g-button-danger",
          "hover-class": "hover",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.gotoPay && _ctx.gotoPay(...args)), ["stop"]))
        }, " 立即支付 ")
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mask",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenCoupon && _ctx.hiddenCoupon(...args))),
            catchtouchmove: "false"
          }))
        : _createCommentVNode("", true),
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", {
                class: "close-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hiddenCoupon && _ctx.hiddenCoupon(...args)))
              }, [
                _createVNode(_component_Icon, {
                  class: "icon",
                  icon: "btn_cancel"
                })
              ])
            ]),
            (_ctx.couponsList.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "coupon-wrapper",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectCoupon && _ctx.selectCoupon(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponsList, (item) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["coupon-card", {
              'is-disabled': !item.availabled,
            }]),
                      key: item.id
                    }, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("img", {
                            src: item.icon_url
                          }, null, 8, _hoisted_58)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, _toDisplayString(item.coupon_name), 1),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, _toDisplayString(item.transaction_minimum > 0
                        ? '满' + item.transaction_minimum + '元可用'
                        : '无门槛'), 1),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(item.all_express_available ? '全线可用' : '部分线路可用'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, " 使用时间 " + _toDisplayString(item.effective_time) + "-" + _toDisplayString(item.expiration_time), 1),
                        (item.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createVNode(_component_Icon, {
                                  class: "icon",
                                  icon: "icon_warning"
                                }),
                                _createTextVNode(" 不可用原因 ")
                              ]),
                              _createElementVNode("div", _hoisted_68, _toDisplayString(item.message), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.availabled)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "radio",
                            class: "g-radio radio",
                            value: item.coupon,
                            checked: item.id === _ctx.selectCouponId
                          }, null, 8, _hoisted_69))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_70, "暂无优惠券可以使用"))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}